import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { HttpUtils } from "../shared/http.utils";
import { DecoderFilters } from "../model/filters/decoder-filters";
import { DecodersResponse } from "../model/responses/decoders-response";
import { DecoderPersistRequest } from "../model/requests/decoder-persist-request";

@Injectable({
  providedIn: 'root'
})
export class DecodersService {

  private readonly decodersURL: string;

  constructor(private http: HttpClient) {
    this.decodersURL = "/catalog/decoders";
  }

  public getDecoderScripts(): Observable<string[]> {
    return this.http.get<string[]>(`${ this.decodersURL }/scripts`);
  }

  public getDecoderScript(name: string): Observable<string> {
    return this.http.get<string>(`${ this.decodersURL }/script/${ name }`, { responseType: 'text' as 'json' });
  }

  public getDecoders(offset?: number, limit?: number, filters?: DecoderFilters): Observable<DecodersResponse>{
    let options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    let body = (filters != null) ? filters : new DecoderFilters();
    return this.http.post<DecodersResponse>(this.decodersURL, body, options);
  }

  public createDecoder(decoderCreationData: DecoderPersistRequest) {
    let url = `${this.decodersURL}/create`;
    return this.http.post<any>(url, decoderCreationData);
  }

  public editDecoder(decoderCreationData: DecoderPersistRequest) {
    let url = `${this.decodersURL}/edit`;
    return this.http.post<any>(url, decoderCreationData);
  }

  public deleteDecoders(identifiers: {tenantUuid: string, name: string}[]) {
    let url = `${this.decodersURL}/delete`;
    return this.http.post<any>(url, identifiers, {observe: 'response'});
  }

}
